import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Col, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Routes from 'routing/Routes';

const AuditLogLicenseStatus = React.createClass({
  propTypes: {
    licenseStatus: PropTypes.shape({
      status: PropTypes.object,
      missing: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
    colWidth: PropTypes.number,
    rowClass: PropTypes.string,
  },

  getDefaultProps() {
    return {
      colWidth: 12,
      rowClass: 'content',
    };
  },

  renderStatus() {
    return (
      <Alert bsStyle="danger">
        <h4 style={{ fontWeight: 'bold', marginBottom: 5 }}>Auditlog is disabled</h4>
        <p>
          Graylog will not write any new auditlog entries because there is no valid license.
        </p>
        <p>
          See <LinkContainer to={Routes.pluginRoute('SYSTEM_LICENSES')}><a>Licenses page</a></LinkContainer> for details.
        </p>
      </Alert>
    );
  },

  render() {
    const { status, missing } = this.props.licenseStatus;

    if (!missing && (status && status.valid)) {
      return null;
    }

    const { rowClass, colWidth } = this.props;

    return (
      <Row className={rowClass}>
        <Col md={colWidth}>
          {this.renderStatus()}
        </Col>
      </Row>
    );
  },
});

export default AuditLogLicenseStatus;




// WEBPACK FOOTER //
// ./src/web/AuditLogLicenseStatus.jsx